import app from '../../forum/app';
import Page, { IPageAttrs } from '../../common/components/Page';
import NotificationList from './NotificationList';
import type Mithril from 'mithril';
import extractText from '../../common/utils/extractText';

/**
 * The `NotificationsPage` component shows the notifications list. It is only
 * used on mobile devices where the notifications dropdown is within the drawer.
 */
export default class NotificationsPage<CustomAttrs extends IPageAttrs = IPageAttrs> extends Page<CustomAttrs> {
  oninit(vnode: Mithril.Vnode<CustomAttrs, this>) {
    super.oninit(vnode);

    app.history.push('notifications', extractText(app.translator.trans('core.forum.notifications.title')));

    app.notifications.clear();
    app.notifications.load();
    

    this.bodyClass = 'App--notifications';
    if (!app.cache.scrollTop) {
      app.cache.scrollTop={}
    }
  }
  oncreate(vnode: Mithril.VnodeDOM<CustomAttrs, this>) {
    super.oncreate(vnode);

    // Work out the difference between the height of this hero and that of the
    // previous hero. Maintain the same scroll position relative to the bottom
    // of the hero so that the sidebar doesn't jump around.
    const scrollTop = app.cache.scrollTop['NotificationsPage'];

    $('#app').css('min-height', ($(window).height() || 0) + scrollTop);

    // Let browser handle scrolling on page reload.
    if (app.previous.type == null) return;

    // Only retain scroll position if we're coming from a discussion page.
    // Otherwise, we've just changed the filter, so we should go to the top of the page.
    if (scrollTop) {
      $(window).scrollTop(scrollTop);
    } else {
      $(window).scrollTop(0);
    }
  }

  onbeforeremove(vnode: Mithril.VnodeDOM<CustomAttrs, this>) {
    super.onbeforeremove(vnode);

    // Save the scroll position so we can restore it when we return to the
    // discussion list.
    app.cache.scrollTop['NotificationsPage'] = $(window).scrollTop();
  }
  onremove(vnode: Mithril.VnodeDOM<CustomAttrs, this>) {
    super.onremove(vnode);

    $('#app').css('min-height', '');
  }

  view() {
    return (
      <div className="NotificationsPage">
        <NotificationList state={app.notifications} type={0}></NotificationList>
      </div>
    );
  }
}
